(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {

      super();

      this.setHeaderHeight = this.setHeaderHeight.bind(this);

    }



    connectedCallback() {

      this.header = document.querySelector('.section-header');

      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');

      this.headerBounds = {};

      this.setHeaderHeight();



      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);



      this.currentScrollTop = 0;

      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);



      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

    }



    setHeaderHeight() {

      if (!this.header) return;



      document.documentElement.style.setProperty(

        '--header-height',

        `${this.header.offsetHeight}px`

      );

    }



    disconnectedCallback() {

      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);

      window.removeEventListener('scroll', this.onScrollHandler);

    }



    createObserver() {

      const observer = new IntersectionObserver((entries, currentObserver) => {

        this.headerBounds = entries[0].intersectionRect;

        currentObserver.disconnect();

      });



      observer.observe(this.header);

    }



    onScroll() {

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;



      if (

        [...this.predictiveSearches].some(

          (predictiveSearch) => predictiveSearch.isOpen

        )

      ) {

        return;

      }



      if (scrollTop > 10) {

        this.header.classList.add('scrolled-past-header');

        this.header.classList.remove('shopify-section-header-hidden');

        this.header.classList.add('shopify-section-header-sticky');

      } else {

        this.header.classList.remove('scrolled-past-header');

        this.header.classList.remove('shopify-section-header-hidden');

      }



      this.currentScrollTop = scrollTop;

    }



    hide() {

      return;

    }



    reveal() {

      if (!this.header) return;



      this.header.classList.add('shopify-section-header-sticky');

      this.header.classList.remove('shopify-section-header-hidden');

    }



    reset() {

      if (!this.header) return;



      this.header.classList.remove('shopify-section-header-hidden');

    }



    closeMenuDisclosure() {

      this.disclosures =

        this.disclosures || this.header.querySelectorAll('header-menu');



      this.disclosures.forEach((disclosure) => disclosure.close());

    }



    closeSearchModal() {

      this.searchModals =

        this.searchModals || this.header.querySelectorAll('details-modal');



      this.searchModals.forEach((searchModal) => searchModal.close(false));

    }

  }



  if (!customElements.get('sticky-header')) {

    customElements.define('sticky-header', StickyHeader);

  }


  } catch(e) { console.error(e); }
})();
})();
